module.exports = __webpack_public_path__ + "static/media/place_24px.32199437.svg";